<template>
  <div
    class="custom-icon"
    :style="{
      maskImage: `url(${icon})`,
      width: size,
      height: size,
    }"></div>
</template>

<script setup>
  defineProps({
    icon: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: '20px',
    },
  });
</script>

<style scoped lang="scss">
  .custom-icon {
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
    background-color: currentColor;
  }
</style>
